<template>
  <div class="home">
    <div class="banner min-container">
      <swiper
        v-if="showBanner"
        :options="swiperBannerOption"
      >
        <swiper-slide
          v-for="(item, index) in banner"
          :key="index"
          style="height: 410px;"
        >
          <a
            v-if="item.link"
            :style="item.style"
            class="banner_img"
            aria-label="banner_img"
            :href="item.link"
            target="_blank"
          />
          <a
            v-else
            :style="item.style"
            class="banner_img"
            aria-label="banner_img"
          />
        </swiper-slide>
        <div
          v-if="banner.length > 1"
          slot="pagination"
          class="swiper-pagination"
        />
        <div
          v-if="banner.length > 1"
          slot="button-prev"
          class="swiper-button-prev"
        />
        <div
          v-if="banner.length > 1"
          slot="button-next"
          class="swiper-button-next"
        />
      </swiper>
    </div>
    <img
      v-if="show_arrow"
      src="/official/static/img/festival/float_arrow.png"
      class="float_arrow"
      @click="toScroll('pastevent-title')"
    >
    <div class="middle">
      <div class="upcommint_bg">
        <div class="container">
          <p class="upcoming-title home-color">
            {{ $t('common.p58') }}
          </p>
          <swiper :options="swiperOption">
            <swiper-slide
              v-for="item in upcomingList"
              :key="item.id"
            >
              <img
                :src="'/official/static/img/festival/flat/' + item.platform + '.jpg'"
                class="upcoming-item-bg"
              >
              <div class="upcoming-item-bg-before" />
              <div
                class="upcoming-item"
                @click="toFestivalUpcomingItem(item.id)"
              >
                <p class="p1">
                  {{ item.title }}
                </p>
                <div class="div-con">
                  <p class="p2">
                    {{ item.city }}
                  </p>
                  <p class="p3">
                    <span style="color: #757575;">Buy-in</span> {{ item.buyin }}
                  </p>
                  <p class="p4">
                    {{ item.gtd_prize }} <span style="color: #757575;font-size:16px;">GTD</span>
                  </p>
                </div>
                <div class="div-bottom">
                  <img
                    :src="'/official/static/img/festival/flat/' + item.platform + '.jpg'"
                    alt=""
                  >
                  <p class="p5">
                    {{ item.startDate | format }} - {{ item.endDate | format }}
                  </p>
                </div>
              </div>
            </swiper-slide>
            <div
              v-show="upcomingList.length > 3"
              slot="button-prev"
              class="swiper-button-prev"
            />
            <div
              v-show="upcomingList.length > 3"
              slot="button-next"
              class="swiper-button-next"
            />
          </swiper>
          <div
            v-if="upcomingList.length === 0"
            class="to_be_announced"
          >
            <div style="position:relative; display: inline-block; width: 31%;">
              <div class="to_be_announced_city home-color">
                Europe
              </div>
              <div class="to_be_announced_p home-color">
                {{ $t('common.p59') }}
              </div>
              <img
                src="/official/static/img/festival/europe.jpg"
                alt=""
              >
            </div>
            <div style="position:relative; display: inline-block; width: 31%;">
              <div class="to_be_announced_city home-color">
                Americas
              </div>
              <div class="to_be_announced_p home-color">
                {{ $t('common.p59') }}
              </div>
              <img
                src="/official/static/img/festival/americas.jpg"
                alt=""
              >
            </div>
            <div style="position:relative; display: inline-block; width: 31%;">
              <div class="to_be_announced_city home-color">
                Asia - Pacific
              </div>
              <div class="to_be_announced_p home-color">
                {{ $t('common.p59') }}
              </div>
              <img
                src="/official/static/img/festival/asia_pacific.jpg"
                alt=""
              >
            </div>
          </div>
        </div>
      </div>
      <div class="pastevent_bg">
        <div class="container">
          <p class="pastevent-title">
            {{ $t('common.p60') }}
          </p>
          <div class="pastevent-con">
            <div
              v-for="item in pasteventList"
              :key="item.id"
              class="pastevent_item"
              @click="toFestivalItem(item.id)"
            >
              <img
                :src="item.headImage"
                alt=""
              >
              <div class="img_content">
                <p class="p1">
                  {{ item.title }}
                </p>
                <p class="p2">
                  {{ item.subtitle }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="about_bg">
        <div class="container">
          <p class="home-color about-title">
            {{ $t('common.p73') }}
          </p>
          <div class="content">
            <p class="home-p-color">
              {{ $t('event.p4') }}
            </p>
            <br>
            <p class="home-p-color">
              {{ $t('event.p5') }}
            </p>
            <img src="/official/static/img/festival/picture_logo_festival.svg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getFestivalBanner, getFestivalPreviewMatch, getFestivalHistoryMatch } from '@/api/official'
import moment from 'moment'

export default {
  components: {
    swiper,
    swiperSlide
  },
  filters: {
    format: function (date) {
      return moment(date).format('MMM D, YYYY')
    }
  },
  data () {
    return {
      eventName: 'upcoming-title',
      upcomingList: [],
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 26,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      showBanner: true,
      swiperBannerOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      banner: [],
      pasteventList: [],
      show_arrow: true
    }
  },
  created () {
    this.$store.commit('changeTab', '/events')
    this.initData()
  },
  mounted () {
    document.querySelector('#app').scrollIntoView({ block: 'start', behavior: 'smooth' })
    window.addEventListener('scroll', () => {
      let scrollt = document.documentElement.scrollTop + document.body.scrollTop
      if (scrollt > 10) {
        this.show_arrow = false
      }
      if (scrollt === 0) {
        this.show_arrow = true
      }
    })
  },
  methods: {
    initData () {
      getFestivalBanner()
        .then(res => {
          this.banner = res.data.list.map(v => {
            return {
              style: {
                backgroundImage:
                  'url(' + v.pcImage + ')'
              },
              link: v.jumpUrl
            }
          })

          if (this.banner.length < 2) {
            this.swiperBannerOption = {}

            this.showBanner = false
            this.$nextTick(() => {
              this.showBanner = true
            })
          }
          this.showBanner = false
          this.$nextTick(() => {
            this.showBanner = true
          })
        })
        .catch(err => {
          console.log(err)
        })

      getFestivalPreviewMatch()
        .then(res => {
          this.upcomingList = res.data.list.map(v => {
            return {
              ...v, title: v.lang[this.$i18n.locale]
            }
          })
        })
        .catch(err => {
          console.log(err)
        })

      getFestivalHistoryMatch()
        .then(res => {
          this.pasteventList = res.data.list.map(v => {
            return {
              ...v.lang[this.$i18n.locale], id: v.id, headImage: v.headImage
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    toFestivalUpcomingItem (item) {
      this.$router.push({ name: 'festival-upcoming', params: { id: item } })
    },
    toFestivalItem (item) {
      this.$router.push({ name: 'festival-past', params: { id: item } })
    },
    toScroll (target) {
      this.eventName = target
      if (target === 'upcoming-title') {
        document
          .querySelector('.top')
          .scrollIntoView({ block: 'start', behavior: 'smooth' })
      } else {
        document
          .querySelector('.' + target)
          .scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@-webkit-keyframes d {
  0% {
    -webkit-transform: translateX(-50%) translateY(0);
    transform: translateX(-50%) translateY(0);
  }
  100% {
    -webkit-transform: translateX(-50%) translateY(8px);
    transform: translateX(-50%) translateY(8px);
  }
}
@keyframes d {
  0% {
    -webkit-transform: translateX(-50%) translateY(0);
    transform: translateX(-50%) translateY(0);
  }
  100% {
    -webkit-transform: translateX(-50%) translateY(8px);
    transform: translateX(-50%) translateY(8px);
  }
}
.home {
  position: relative;
  padding: 0;
  .banner {
    position: relative;
    height: 410px;
    z-index: 1;
    background-color: #000;
    .banner_img {
      display: block;
      width: 100%;
      height: 410px;
      background-position: center center;
      background-repeat: no-repeat;
    }
    /deep/.el-carousel__arrow {
      font-size: 30px;
    }
    .swiper-button-prev {
      background: url("/official/static/img/home/arrow_l.png") center center;
      background-size: 100%;
    }
    .swiper-button-next {
      background: url("/official/static/img/home/arrow_r.png") center center;
      background-size: 100%;
    }
    .swiper-pagination {
      bottom: 25px;
      z-index: 5;
      /deep/.swiper-pagination-bullet {
        width: 46px;
        border-radius: 0px;
        margin: 0 10px;
      }
      /deep/.swiper-pagination-bullet-active {
        background: #1f9d56;
      }
    }
  }
  .top {
    position: relative;
    width: 100%;
    height: 57px;
    background-color: #000000;
    .top_title {
      font-size: 24px;
      color: #fff;
      a {
        cursor: pointer;
        line-height: 57px;
        color: #767676;
        margin: 0 20px;
      }
      a:nth-child(1) {
        margin-left: 0px;
      }
      .highlight {
        color: #158054;
      }
    }
  }
  .float_arrow {
    position: fixed;
    width: 60px;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    z-index: 2;
    cursor: pointer;
    -webkit-animation: 0.8s linear infinite alternate d;
    animation: 0.8s linear infinite alternate d;
  }
  .middle {
    // background: url("/official/static/img/festival/bg_02.jpg") center center;
    // background-repeat: repeat;
    min-width: 1200px;
    padding: 0px 0px 65px 0px;
    .upcommint_bg {
      // padding-top: 20px;
      // background: url("/official/static/img/festival/bg_03.png") center bottom;
      // background-repeat: no-repeat;
      width: 100%;
      height: 360px;
      .swiper-button-prev {
        background: url("/official/static/img/home/arrow_l.png") no-repeat center center;
        // padding: 20px;
        background-size: 32px;
      }
      .swiper-button-next {
        background: url("/official/static/img/home/arrow_r.png") no-repeat center center;
        // padding: 20px;
        background-size: 32px;
      }
    }
    .upcoming-title {
      font-size: 30px;
      margin-top: 65px;
      margin-bottom: 26px;
      font-weight: bold;
    }
    .to_be_announced {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .to_be_announced_city {
        position: absolute;
        width: 100%;
        height: 30px;
        left: 0px;
        top: 54px;
        text-align: center;
        font-size: 26px;
        text-shadow: 1px 1px 1px #000;
      }
      .to_be_announced_p {
        position: absolute;
        width: 100%;
        height: 50px;
        left: 0px;
        top: 86px;
        text-align: center;
        font-size: 26px;
        text-shadow: 1px 1px 1px #000;
      }
      img {
        display: inline-block;
        width: 100%;
      }
    }
    .upcoming-item-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      display: block;
      // opacity: 0.2;
      background-color: #000;
      z-index: -2;
    }
    .upcoming-item-bg-before {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      display: block;
      opacity: 0.9;
      z-index: -1;
      background-color: #202020;
    }
    .upcoming-item {
      position: relative;
      // width: 380px;
      width: 100%;
      height: 211px;
      text-align: center;
      // background-color: #333;
      // background: url("/official/static/img/festival/guoqi.jpg") center center;
      // background-repeat: repeat;
      cursor: pointer;
      .p1 {
        font-size: 18px;
        padding: 8px 0px;
        border-bottom: 1px solid #3d3d3d;
      }
      .div-con {
        position: relative;
        width: 100%;
        height: 132px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        .p2 {
          font-size: 32px;
          margin-top: 0px;
          font-weight: bold;
        }
        .p3 {
          font-size: 20px;
        }
        .p4 {
          font-size: 24px;
          margin-bottom: 8px;
        }
        .buyin {
          display: inline-block;
          width: 56px;
          height: 17px;
          color: #000;
          font-size:16px;
          background: url("/official/static/img/festival/buy_in.png") center center;
          text-align: center;
          line-height: 17px;
          vertical-align: middle;
        }
      }
      .div-bottom {
        position: absolute;
        width: 100%;
        height: 40px;
        bottom: 0px;
        left: 0px;
        background-color:#1f9d56;
        img {
          position: absolute;
          width: 40px;
          height: 26px;
          left: 10px;
          top: 7px;
        }
        .p5 {
          line-height: 40px;
          font-size: 18px;
          color: #fff;
        }
      }
    }

    .pastevent_bg {
      background-color: transparent;
      border-width: 80px 0px 140px 0px;
      border-style: solid;
      border-image-slice: 80 0 140 0 fill;
      border-image-repeat: stretched;
      border-image-source: url("/official/static/img/festival/bg_g_middle.png");
      background-color: #1f9d56\9;
    }
    .pastevent-title {
      font-size: 30px;
      margin-top: 40px;
      margin-bottom: 30px;
      color: #fff;
      font-weight: bold;
    }
    .pastevent-con {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .pastevent_item {
        position: relative;
        width: 578px;
        height: 333px;
        background-color: #111111;
        margin-bottom: 40px;
        cursor: pointer;
        img {
          width: 100%;
          display: block;
        }
        .img_content {
          position: absolute;
          left: 0px;
          bottom: 0px;
          width: 100%;
          background-color: rgba(0, 0, 0, 0.8);
          padding: 8px 0px;
          text-align: left;
          .p1 {
            font-size: 18px;
            line-height: 26px;
            padding: 0px 21px;
          }
          .p2 {
            font-size: 14px;
            line-height: 18px;
            padding: 0px 21px;
          }
        }
      }
    }

    .about_bg {
      background: url('/official/static/img/festival/bg_logo.jpg') no-repeat right top;
      width: 100%;
      padding: 0px;
      margin-top: -70px;
    }

    .about-title {
      font-size: 30px;
      margin-top: 80px;
      margin-bottom: 30px;
      font-weight: bold;
      p {
        font-size: 14px;
        line-height: 18px;
      }
    }
    .content {
      p {
        line-height: 30px;
      }
      img {
        margin-top: 30px;
        width: 100%;
      }
    }
  }
}
</style>
